<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [datasource]="projectsDataSource"
      [rowModelType]="'infinite'"
      [columns]="columns"
      [title]="'profile.myProjects.submittedPageTitle' | translate"
      detailsBaseRoute="/project-wizard"
      [loading]="isLoading()"
      [showSearch]="false"
    />
  </div>
</div>
